import axios from "axios";

axios.defaults.params = {};
axios.defaults.params.token = "23e528868885cfcc350cfd48c21e0431";
axios.defaults.params.hash = "d69fe32491217e5b0acfea9908953eb2";
axios.defaults.params.client = 3;
export default {

    /**
     * Current version of the api.
     * 
     * @var string
     */
    version: "v1",
    /**
     * Base URL of the api.
     * 
     * @var string
     */
    baseUrl: "https://ms.pafcpic.ph/api/",
    // baseUrl: "https://dev.ms.pafcpic.ph/api/",
    // baseUrl: "http://127.0.0.1:8000/api/",
    /**
     * Generate an api endpoint.
     * 
     * @param path string
     * @returns string
     */
    endpoint(path : string) : string {
        if(path.substring(0, 1) == "/")
        {
            path = path.substring(1, path.length);
        }

        return this.baseUrl + this.version + "/" + path;
    },

    /**
     * Make a GET request to the API endpoint.
     * 
     * @param path string
     * @param params object
     * @returns any
     */
    get(path : string, params = {}) {
        return axios.get(this.endpoint(path), {
            params: params,
            withCredentials: true,
        });
    },

    /**
     * Make a POST request to the API endpoint.
     * 
     * @param path string
     * @param params object
     * @returns any
     */
    post(path : string, params = {}) {
        return axios.post(this.endpoint(path), params);
    },

    /**
     * Make a PUT request to the API endpoint.
     * 
     * @param path string
     * @param params object
     * @returns any
     */
    put(path : string, params = {}) {
        return axios.put(this.endpoint(path),params);
    },

    /**
     * Make a PATCH request to the API endpoint.
     * 
     * @param path string
     * @param params object
     * @returns any
     */
    patch(path : string, params = {}) {
        return axios.patch(this.endpoint(path), {
            params: params,
            withCredentials: true,
        });
    },

    /**
     * Make a DELETE request to the API endpoint.
     * 
     * @param path string
     * @param params object
     * @returns any
     */
    delete(path : string, params = {}) {
        return axios.delete(this.endpoint(path), {
            params: params,
            withCredentials: true,
        });
    },
}
